import React from "react";

// MATERIAL UI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingBox({ height = 100, heightMetric = "vh" }) {
  return (
    <Box sx={{ display: "flex", height: `${height}${heightMetric}` }}>
      <Stack
        spacing={2}
        sx={{
          m: "auto",
        }}
      >
        <CircularProgress sx={{ "&:focus-visible": { border: "none" } }} />
      </Stack>
    </Box>
  );
}
